module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mdl-switch mdl-js-switch mdl-js-ripple-effect",
    attrs: {
      "for": _vm.id
    }
  }, [_c('input', {
    ref: "cbox",
    staticClass: "mdl-switch__input",
    attrs: {
      "id": _vm.id,
      "type": "checkbox",
      "name": _vm.id
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": _vm.onChange
    }
  }), _c('span', {
    staticClass: "mdl-switch__label",
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84b52936","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/form/Switch.vue
// module id = 534
// module chunks = 1